export default {"src":"/_next/static/media/cescta_combologo.7b66f040.svg","height":53,"width":95,"blurWidth":0,"blurHeight":0};